import React, {useEffect} from "react";
import {useParams} from 'react-router-dom';

import * as T from 'utils/types';
import { 
    Button,
    Select,
    Skeleton,
    List,
    Grid
} from "antd";
import {useDispatch, useSelector} from "react-redux";
import TotalResult from "components/panel/TotalResult";
import profilePg_smtPubTab_S, { profilePg_smtPubTab_Thunks } from "./smtPubTabSlice";

import Error500 from "components/errors/Error500";
import ToHomeButton from "components/ToHomeButton";
import SmtPublicationTitle from "components/smtPublication/SmtPublicationTitle";
import SmtPublicationDescription from "components/smtPublication/SmtPublicationDescription";
import "features/content/search_page/components/TabBlock/PubTab/AltmetricBadge.css";

const {Option}=Select;

// ProfilePage SummitTab
export default () => {
    const screens = Grid.useBreakpoint();
    const breakpoint = screens.md;

    useEffect(() => {
        // _altmetric_embed_init is offered by Altmetric in embeded.js file
        // this func will let js to find new altmetric-embed div and fetch the data for them
        // eslint-disable-next-line
        eval('if(typeof _altmetric_embed_init!="undefined"){_altmetric_embed_init();}');
    })

    const { randomID } = useParams<{ randomID: string }>();


    const {
        total,
        status,
        hasNext,
        smtPubList,
    } = useSelector((state: T.RootState) => state.profilePg_smtPubTab);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(profilePg_smtPubTab_Thunks.initList({randomID,}));
    }, [dispatch, randomID]);

    if (status==="failed") {
        return (<Error500 extra={<ToHomeButton/>}/>);
    }

    return <>
        {total>=0&&<TotalResult searchResult={total}/>}

         <List
            loading={status==="idle"}
            itemLayout="horizontal"
            loadMore={
                hasNext ? <div
                    style={{
                        textAlign: 'center',
                        marginTop: 12,
                        height: 32,
                        lineHeight: '32px',
                    }}
                >
                    <Button
                        className="sub-heading-font"
                        onClick={() => dispatch(profilePg_smtPubTab_Thunks.loadMore({randomID}))}
                    >
                        More
                    </Button>
                </div> : null
            }
            dataSource={smtPubList}
            renderItem={ item => {
                const pub = item.item as T.SmtPublication;
                return <List.Item>
                    <Skeleton avatar title={false} loading={item.loading} active>
                        <List.Item.Meta

                            title={ <SmtPublicationTitle smtPub={pub}/> }

                            description={ <SmtPublicationDescription smtPub={pub}/> }

                        />
                    </Skeleton>
                </List.Item>;
            } }
        />

    </>;
}
